export default "__VITE_ASSET__ilWWEIiB__"